import { EnvironmentConfig } from '@shared/interfaces/environment-config';

export function getLang(environmentConfig: EnvironmentConfig) {
  const defaultLanguage = environmentConfig.defaultLang;
  const userLanguage = localStorage.getItem('lang');
  if (userLanguage && environmentConfig.langs.includes(userLanguage)) {
    return userLanguage;
  } else {
    localStorage.setItem('lang', defaultLanguage);
    return defaultLanguage;
  }
}
